import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CleanablesStoreEffects } from './effects';
import { cleanablesReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('cleanables', cleanablesReducer),
    EffectsModule.forFeature([CleanablesStoreEffects]),
  ],
})
export class CleanablesStoreModule {}
